import { Stack } from '@mui/material';
import { Handle, Position } from '@xyflow/react';

import {
  PERSON_BOTTOM_HANDLE_ID,
  PERSON_TOP_HANDLE_ID,
} from '../utils/elkLayout.constants';
import { PersonTile, PersonTileProps } from './PersonTile';

type PersonNodeProps = PersonTileProps;

export function PersonNode(props: PersonNodeProps) {
  const personId = props.data?.person?.personId;

  return (
    <Stack
      width={props.width}
      data-testid={personId ? `person-node-${personId}` : undefined}
    >
      <Handle
        id={PERSON_TOP_HANDLE_ID}
        type="target"
        position={Position.Top}
        style={{ opacity: 0 }}
      />
      <PersonTile {...props} />
      <Handle
        id={PERSON_BOTTOM_HANDLE_ID}
        type="source"
        position={Position.Bottom}
        style={{ opacity: 0 }}
      />
    </Stack>
  );
}
